<template lang="html">
  <div class="center">
    <div class="inner">
      <div class="body">
        <h3 style="text-align:center;">选择节目</h3>
        <div
          v-for="show in shows"
          :key="show.id"
          class="item"
          @click="showDetail(show.slug)"
        >
          <el-card
            shadow="hover"
          >
            {{show.title}}
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {},
    data () {
      return {
        shows: []
      }
    },
    methods: {
      showDetail (slug) {
        window.console.log("跳转到show")
        window.console.log(slug)
        this.$router.replace({
          name: 'ShowDetail',
          params: {
            slug: slug
          }
        })
      }
    },
    mounted () {
      let that = this
      that.$api.show.list().then(res => {
        that.shows = res.data
        window.console.log(res)
      })
    }
  }
</script>

<style lang="css" scoped>
  .body {
    padding: 15px 30px 15px 30px;
  }
  .item {
    margin: 10px 0;
    cursor: pointer;
  }
  .center {
    position: absolute;
    width: 100%;
    /* background: #303133; */
    background: #f5f6fa;
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
  .inner {
    width: 400px;
    background: #fff;
    border-radius: 3px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.07);
  }
</style>
